import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { ModelYhcSpecialLeadTimes } from './yhcDataTypes'

type YhcSpecialLeadTimesRecord = ModelYhcSpecialLeadTimes & {
  id?: number
  fromPref?: string | null
  toPref?: string | null
}

/**
 * エリア外マスタ（特殊リードタイム）
 * - 離島など通常のリードタイムと異なる発着エリアの所要日数を管理する
 */
export const yhc_special_lead_times: ModelDef<YhcSpecialLeadTimesRecord> = {
  tableName: 'yhc_special_lead_times',
  tableLabel: 'エリア外マスタ',
  tableComment: '離島など通常のリードタイムと異なるマスタ',
  primaryKeyColType: 'NUMBER',
  columns: {
    fromPrefCode: {
      type: 'STRING',
      label: '発エリアコード',
      replicable: true,
    },
    fromPref: {
      type: 'STRING',
      label: '発都道府県',
      replicable: true,
    },
    toPrefCode: {
      type: 'STRING',
      label: '着エリアコード',
      replicable: true,
    },
    toPref: {
      type: 'STRING',
      label: '着都道府県',
      replicable: true,
    },
    toCity: {
      type: 'STRING',
      label: '着市区郡',
      replicable: true,
    },
    toTown: {
      type: 'STRING',
      label: '着町村番地',
      replicable: true,
    },
    sizeRank0NeedDays: {
      type: 'STRING',
      label: '最短所要日数 (サイズランクE以下)',
      replicable: true,
    },
    sizeRank1NeedDays: {
      type: 'STRING',
      label: '最短所要日数 (サイズランクFG)',
      replicable: true,
    },
  },
}
